import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { toast } from "react-toastify";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      staleTime: 1000 * 3, // 3 seconds
    },
  },
  mutationCache: new MutationCache({
    onError: () => {
      toast.error("Unable to perform action", {
        toastId: "mutation-error",
      });
    },
  }),
  queryCache: new QueryCache({
    onError: () => {
      toast.error("Unable to retrieve data", {
        toastId: "query-error",
      });
    },
  }),
});

export const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister,
});
